const PanelRow = ({children}) => {

    return (
        <div className="col-12 d-flex flex-column flex-lg-row justify-content-evenly">
            {children}
        </div>
    );
}

export default PanelRow;